import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { usersProfileReducer } from './reducer';
import {

  updateProfile,

  addUserPofile,
  checkUniqueAadharAction,
  checkUniquePanAction,
  checkUniquePassportAction,
  checkUniqueUanAction,
  
} from './actions';
import { UsersProfileTypes } from './usersProfileTypes';

export const usersProfileSlice = createSlice({
  name: 'usersProfils',
  initialState,
  reducers: usersProfileReducer,
  extraReducers: {
   [updateProfile.pending.toString()]: (state: UsersProfileTypes) => ({
      ...state,
      fetching: true
    }),
    [updateProfile.fulfilled.toString()]: (state: UsersProfileTypes, { payload }) => {
    const { success, message, result = {}, status_code } = payload;
    
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,

        }
      }
      return {
          ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message

      }
    },
    [updateProfile.rejected.toString()]: (state: UsersProfileTypes, { error }) =>({
      ...state,
       fetching: false,
      success:0,
      error:error?.message,
    }),

    [addUserPofile.pending.toString()]: (state: UsersProfileTypes) => ({
      ...state,
      fetching: true
    }),
    [addUserPofile.fulfilled.toString()]: (state: UsersProfileTypes, { payload }) => {
    const { success, message, result = {}, status_code } = payload;
    
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
          statusCode: status_code,
        }
      }
      return {
          ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message

      }
    },
    [addUserPofile.rejected.toString()]: (state: UsersProfileTypes, { error }) =>({
      ...state,
       fetching: false,
      success:0,
      error:error?.message,
    }),

    [checkUniqueAadharAction.pending.toString()]: (state: UsersProfileTypes) => ({
      ...state,
      aadhaarFetching: true
    }),
    [checkUniqueAadharAction.fulfilled.toString()]: (state: UsersProfileTypes, { payload }) => {
    const { success, message, result = {}, status_code,is_duplicate } = payload;
    
      if (success === 0) {
        return {
          ...state,
          aadhaarFetching: false,
          aadhaarError: message,
          aadhaarSuccess: success,
          isAadhaarNo:is_duplicate,
            statusCodeAadhaar: status_code,
           
        }
      }
      return {
        ...state,
        aadhaarFetching: false,
        aadhaarSuccess:success,
        // fetching: false,
        
        aadhaarMessage: message,
        isAadhaarNo:is_duplicate,
        statusCodeAadhaar: status_code,
      }
    },
    [checkUniqueAadharAction.rejected.toString()]: (state: UsersProfileTypes, { error }) =>({
      ...state,
       panFetching: false,
      //  aadhaarError:  error?.message,
      //  panSuccess:0,
         success:0,
       error:error.message
    }),
    
    [checkUniquePanAction.pending.toString()]: (state: UsersProfileTypes) => ({
      ...state,
      panFetching: true
    }),
    [checkUniquePanAction.fulfilled.toString()]: (state: UsersProfileTypes, { payload }) => {
    const { success, message, result = {}, status_code,is_duplicate } = payload;
    
      if (success === 0) {
        return {
          ...state,
          panFetching: false,
          panError: message,
          panSuccess: success,
          isPanNo:is_duplicate,
          statusCodePan: status_code,
        }
      }
      return {
        ...state,
        panFetching: false,
        panSuccess:success,
        // fetching: false,
        statusCodePan: status_code,
        panMessage: message,
        isPanNo:is_duplicate,

      }
    },
    [checkUniquePanAction.rejected.toString()]: (state: UsersProfileTypes, { error }) =>({
      ...state,
       panFetching: false,
      //  panError:  error?.message,
      // panSuccess: 0,
      success:0,
       error:error.message
    }),

    [checkUniquePassportAction.pending.toString()]: (state: UsersProfileTypes) => ({
      ...state,
      passportFetching: true
    }),
    [checkUniquePassportAction.fulfilled.toString()]: (state: UsersProfileTypes, { payload }) => {
    const { success, message, result = {}, status_code,is_duplicate } = payload;
    
      if (success === 0) {
        return {
          ...state,
          passportFetching: false,
          passportError: message,
          passportSuccess: success,
          isPassportNo:is_duplicate,
          statusCodePassport: status_code,
           
        }
      }
      return {
        ...state,
        passportFetching: false,
        passportMessage: message,
        passportSuccess: success,
        isPassportNo:is_duplicate,
        statusCodePassport: status_code,
         
      }
    },
    [checkUniquePassportAction.rejected.toString()]: (state: UsersProfileTypes, { error }) =>({
      ...state,
       passportFetching: false,
         success:0,
       error:error.message
    })
    ,
    [checkUniqueUanAction.pending.toString()]: (state: UsersProfileTypes) => ({
      ...state,
      uanFetching: true
    }),
    [checkUniqueUanAction.fulfilled.toString()]: (state: UsersProfileTypes, { payload }) => {
    const { success, message, result = {}, status_code,is_duplicate } = payload;
    
      if (success === 0) {
        return {
          ...state,
          uanFetching: false,
          uanError: message,
          uanSuccess: success,
          isUanNo:is_duplicate,
          statusCodeUan: status_code
           
        }
      }
      return {
        ...state,
        uanFetching: false,
        uanMessage: message,
        uanSuccess: success,
        isUanNo:is_duplicate,
        statusCodeUan: status_code
         
      }
    },
    [checkUniqueUanAction.rejected.toString()]: (state: UsersProfileTypes, { error }) =>({
      ...state,
       uanFetching: false,
         success:0,
       error:error.message
    })
    
  }
}
);

export const {
  resetError: resetUsersProfileError,
  resetSuccess: resetUsersProfileSuccess,
  resetUsersProfileMessage,
  resetUsersProfileFetching,
  resetPanMessage,
  resetPanError,
  resetStatusCodePan,
  resetAadhaarMessage,
  resetAadhaarError,
  resetStatusCodeAadhaar,
  resetPanSuccess,
resetAaddharSuccess,
resetPassportError,
resetPassportMessage,
resetPassportSuccess,
resetStatusCodePassport,
resetUanError,
resetUanMessage,
resetUanSuccess,
resetStatusCodeUan
} = usersProfileSlice.actions;